import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Seo from "components/Seo";
import { ReactComponent as ArrowBack } from "assets/common/common/arrowBack.svg";
import { useGetAddressView } from "hooks/morning/useGetAddressView";
import { AddressRegistration } from "../../-components/AddressBook";

export default function MyPageAddressRegister() {
    const navigate = useNavigate();
    const { idx } = useParams();
    const { data } = useGetAddressView(idx);
    const isModify = Boolean(idx);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="마이페이지" />
            <div className="bg-white min-h-[100dvh] flex fixed z-[88888] inset-0 overflow-hidden">
                <div className="w-full h-full max-w-[680px] mx-auto flex flex-col border-l border-r border-[#dddddd] responsive650:border-none">
                    <div className="relative text-[#262A34] text-[20px] text-center font-[500] py-[16px]">
                        주소록 추가/수정
                        <ArrowBack onClick={() => navigate(-1)} className="absolute top-1/2 -translate-y-1/2 left-[16px]" />
                    </div>
                    <div className="flex-1 flex overflow-hidden">
                        <AddressRegistration
                            data={{
                                idx: Number(data?.idx),
                                c_code: data?.c_code ?? "",
                                a_company: data?.a_company ?? "",
                                a_tel: data?.a_tel ?? "",
                                a_name: data?.a_name ?? "",
                                a_mobile: data?.a_mobile ?? "",
                                a_post: data?.a_post ?? "",
                                a_address: data?.a_address ?? "",
                                a_address_detail: data?.a_address_detail ?? "",
                            }}
                            done={() => {
                                navigate(-1);
                            }}
                            isModify={isModify}
                            isPopup={false}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
